import * as app from './modules/app'
import * as home from './modules/home'
import * as user from './modules/user'
import * as plat from './modules/plat'

export default { ...app, ...home, ...user, ...plat }
